import React, {
    FunctionComponent as FC,
  } from 'react';
  import './index.scss';

  interface TableCellProps {
    attrName: string;
    attrValue: number;
  }

    const TableCell: FC<TableCellProps> = (props) => {
    const { attrName, attrValue } = props
    const fullText = `${attrName}: ${attrValue}`

    return (
        <div className='cell-unit' title={fullText}>
            <div className='attr-name'>{ attrName }</div>
            <div className='attr-value'>{ attrValue }</div>
        </div>
    )
  }

  export default TableCell;